module.exports = __webpack_public_path__ + "img/curtain_up_60.45dd131d.svg";